import React from "react";
import {EMFCModeReportView} from "./EMFCModeReportView";
import {EMInterimReportView} from "./EMInterimReportView";
import {DPOReportView} from "./DPOReportView";
import {CustomsReportView} from "./CustomsReportView";
import {EMVATReportView} from "./EMVATReportView";
import {HS6PReportView} from "../component/HS6PReportView"
import {Tabs} from "antd";
import '../styles/Report.css'

export const Reports = ()=>{
    return <React.Fragment>
        <div className={`report`}>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="EM FC Mode Reports" key="1">
                    <EMFCModeReportView/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="EM Interim Reports" key="2">
                    <EMInterimReportView/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="DPO Reports" key="3">
                    <DPOReportView/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Customs Reports" key="4">
                    <CustomsReportView/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="EM VAT Reports-Standard" key="5">
                    <EMVATReportView/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="HS6+ Subcontractor Reports" key="6">
                    <HS6PReportView/>
                </Tabs.TabPane>
            </Tabs>
        </div>
    </React.Fragment>
}
